import App from "./App.vue";
import Vue from "vue";
import VueGtag from "vue-gtag";
import VueCrontab from "vue-crontab";
import router, { scheduleFairDayMiddayReload } from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTwitter,
  faInstagram,
  faXTwitter,
  faFacebook,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faTwitter,
  faXTwitter,
  faFacebook,
  faLinkedin,
  faInstagram,
  faGlobe
);
Vue.config.productionTip = false;
Vue.use(VueCrontab);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GA_ID },
  },
  router
);

scheduleFairDayMiddayReload();

new Vue({
  router,
  render: (h) => h(App),
  vuetify,
  store,
}).$mount("#app");
